import { useState } from 'react'
import { geocode } from '../lib/api.js'

const TYPE_ICON = { latlng: '⌖', address: '📍' }

// Location search: address or decimal lat/lng. On a single hit it flies there;
// multiple hits show a pick list. onGoto receives { lat, lng, label, type }.
export default function SearchBox({ onGoto }) {
  const [q, setQ] = useState('')
  const [results, setResults] = useState(null) // null = idle, [] handled via error
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  function reset() {
    setResults(null)
    setError('')
  }

  async function submit(e) {
    e.preventDefault()
    const query = q.trim()
    if (!query) return
    setBusy(true)
    reset()
    try {
      const found = await geocode(query)
      if (found.length === 0) {
        setError('No match found.')
      } else if (found.length === 1) {
        onGoto(found[0])
      } else {
        setResults(found)
      }
    } catch (err) {
      setError(err.message || 'Search failed')
    } finally {
      setBusy(false)
    }
  }

  function pick(r) {
    onGoto(r)
    reset()
  }

  return (
    <div className="search-box">
      <form onSubmit={submit}>
        <span className="search-icon" aria-hidden>🔍</span>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              reset()
              e.currentTarget.blur()
            }
          }}
          placeholder="Search an address or lat,lng"
          aria-label="Search for a location"
        />
        {q && (
          <button
            type="button"
            className="search-clear"
            onClick={() => {
              setQ('')
              reset()
            }}
            aria-label="Clear search"
          >
            ×
          </button>
        )}
      </form>

      {(busy || error || results) && (
        <div className="search-dropdown">
          {busy && <div className="search-status">Searching…</div>}
          {error && <div className="search-status search-error">{error}</div>}
          {results && (
            <ul className="search-results">
              {results.map((r, i) => (
                <li key={i} onClick={() => pick(r)}>
                  <span className="r-type">{TYPE_ICON[r.type] || '📍'}</span>
                  <span className="r-label">{r.label}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  )
}
